export const colDataGroupRef = 'col-data-group-external-api';
